<!-- same measure as the page content below (see internal.component.html) so
     the trail aligns with the content column -->
<div class="flex h-14 items-center px-6">
  <div class="mx-auto w-full max-w-6xl">
    <vx-breadcrumb [ariaLabel]="'components.breadcrumbs.label' | transloco">
      @for (crumb of breadcrumbs(); track crumb.link; let last = $last) {
        <vx-breadcrumb-item [link]="last ? null : crumb.link">
          @if (crumb.icon) {
            <vx-icon [name]="crumb.icon" />
          }
          @if (crumb.loading) {
            <vx-skeleton class="h-3.5 w-32" />
          } @else {
            {{ crumb.label | transloco }}
          }
        </vx-breadcrumb-item>
      }
    </vx-breadcrumb>
  </div>
</div>
